import React, { useState } from "react";
import { Box, Grid, Button, Dialog, Grid2 } from "@mui/material";
import AddOutlinedIcon from "@mui/icons-material/AddOutlined";
import AddUser from "./AddUser";
import { getUser } from "../../services/user.service";
// import VisibilityIcon from "@mui/icons-material/Visibility";
import AddEmployee from "../Employee/AddEmployee";
import PermissionGate from "../../components/Permission/PermissionGate";
import { usePermissions } from "../../context/PermissionProvider";
import MasterCommonTable from "../../sharedComponents/MaterCommonTable/MasterCommonTable";
const User = () => {
  const [openDrawer, setOpenDrawer] = useState(false);
  const { canAdd, canEdit, canDelete } = usePermissions();
  const [selectedData, setSelectedData] = useState({});
  const [openEmployeeDrawer, setOpenEmployeeDrawer] = useState(false);
  const [tableTotalCount, setTableTotalCount] = useState(0);
  // const [selectedEmployeeData, setSelectedEmployeeData] = useState({});
  const [openPass, setOpenPass] = useState(false);
  const [data, setData] = useState([]);

  const getData = () => {
    getUser()
      .then((res) => {
        setData(res.data.data);
        setTableTotalCount(res.data.totalCount);
      })
      .catch((error) => {
        console.error("Error fetching data:", error);
      });
  };
  React.useEffect(() => {
    getData();
  }, []);

  const handleAddUser = () => {
    setOpenDrawer(true);
    setSelectedData({});
    setOpenPass(true);
  };
  // const handleAddEmployee = () => {
  //   setOpenEmployeeDrawer(true);
  //   setSelectedEmployeeData({});
  // };
  const handleView = (e) => {
    e.isView = true;
    setOpenDrawer(true);
    setSelectedData(e);
  };
  const columns = [
    { id: "name", label: "Name" },
    { id: "email", label: "Email" },
    { id: "mobileNo", label: "Mobile No" },
  ];

  const tableConfig = {
    isAction: true,
    isAdmin: true,
    // isEdit: true, // User page typically only has view, add handled by button
    isView: true,
  };
  return (
    <div className="mainPageRenderingContainer">
      <Box sx={{ height: "fit-content" }}>
        <Grid container spacing={2} sx={{ justifyContent: "space-between" }}>
          <Grid item xs={12} sm={3} />
          <Grid item xs={12} sm={6} />
          <Grid2 item xs={12} sm={3} sx={{ paddingTop: "10px" }}>
            <PermissionGate module="employee" action="add">
              <Button
                startIcon={<AddOutlinedIcon />}
                onClick={() => handleAddUser()}
                className="Add-Button"
                sx={{ display: "flex", alignItems: "right" }}
              >
                Add User
              </Button>
            </PermissionGate>
          </Grid2>

          {/* <Grid item xs={12} sm={3}>
            <Button
              startIcon={<AddOutlinedIcon />}
              onClick={() => handleAddEmployee()}
              className="Add-Button w-100"
            >
              Add Employee
            </Button>
          </Grid> */}
        </Grid>
      </Box>
      <MasterCommonTable
        tableConfig={tableConfig}
        data={data}
        columns={columns}
        handleView={handleView}
        tableTotalCount={tableTotalCount}
      />

      <Dialog
        open={openDrawer}
        PaperProps={{
          style: {
            width: "100%",
            height: "fit-content",
          },
        }}
        fullWidth
        maxWidth="md"
      >
        {openDrawer ? (
          <AddUser
            selectedData={selectedData}
            setOpenDrawer={setOpenDrawer}
            openPass={openPass}
            formType={
              selectedData.isView ? "view" : selectedData._id ? "edit" : "add"
            }
            GetData={getData}
          />
        ) : null}
      </Dialog>
      <Dialog
        open={openEmployeeDrawer}
        PaperProps={{
          style: {
            width: "100%",
            height: "fit-content",
          },
        }}
        fullWidth
        maxWidth="md"
      >
        {openEmployeeDrawer ? (
          <AddEmployee
            // selectedData={selectedEmployeeData}
            setOpenDrawer={setOpenEmployeeDrawer}
            openPass={openPass}
            // formType={
            //   selectedEmployeeData.isView
            //     ? "view"
            //     : selectedEmployeeData._id
            //     ? "edit"
            //     : "add"
            // }
            // GetData={GetData}
          />
        ) : null}
      </Dialog>
    </div>
  );
};

export default User;
